import { render, staticRenderFns } from "./LaySwiper.vue?vue&type=template&id=b09ab20c&scoped=true&"
import script from "./LaySwiper.vue?vue&type=script&lang=js&"
export * from "./LaySwiper.vue?vue&type=script&lang=js&"
import style0 from "./LaySwiper.vue?vue&type=style&index=0&id=b09ab20c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b09ab20c",
  null
  
)

export default component.exports